import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MeinBoardSeite } from "@/pages/team/MeinBoard";

/**
 * „Mein Board" — eigener Menüpunkt seit dem 14.09.2026 (Eugen: die Startseite
 * bleibt der grobe Überblick). `?aufgabe=<id>` öffnet die Karte — das Ziel
 * der Glocke bei „zugewiesen"/„geteilt".
 */
const suchSchema = z.object({ aufgabe: z.string().min(1).max(100).optional() });

export const Route = createFileRoute("/_angemeldet/_mitarbeiter/board")({
	validateSearch: suchSchema,
	component: BoardSeite,
});

function BoardSeite() {
	const { aufgabe } = Route.useSearch();
	return <MeinBoardSeite oeffneAufgabeId={aufgabe} />;
}
